<template>
  <v-container></v-container>
</template>

<script>
  import { apiResource } from '@/util/resources'

  export default {
    props: ['code', 'state', 'session_state'],
    computed: {
      authenticated () {
        return this.$store.getters.authenticated
      }
    },
    mounted () {
      if (!this.authenticated) {
        this.authenticateUser()
      } else {
        this.$router.push('/')
      }
    },
    methods: {
      authenticateUser () {
        var userData = {
          LoginType: 0,
          code: `${this.code}`,
          state: `${this.state}`,
          session_state: `${this.session_state}`,
          redirectTo: '/'
        }

        this.$store.commit('setLoading', true)
        this.$store.commit('setInitializing', true)
        this.$store.commit('clearError')

        apiResource.post('api/authentication/confirm', userData).then((response) => {
          this.$store.dispatch('authenticateUser', userData)
        }).catch((errorResponse) => {
          console.log('tupas error', errorResponse)
          this.$store.commit('setMessage', { type: 'error', text: 'error.server.0', translate: true })
          this.$store.commit('setLoading', false)
          this.$store.commit('setInitializing', false)
          this.$router.push('/')
        })
      }
    }
  }
</script>
